import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useUnit } from "effector-react";
import { setUser, UserStore } from "../../stores/UserStore/UserStore";
import { ROLES } from "../../types/user.types";
import { userAuth } from "../../services/authService";
import { setLoading } from "../../stores/MainStore/MainStore";
import { publicRoutes } from "../NavWrapper/Menus.consts";

enum AUTH_STATUS {
  AUTH_OK = "AUTH_OK",
  PROCESSING = "PROCESSING",
  NOT_OK = "NOT_OK",
}

const canAccess = (authorizedRoles: ROLES[] | undefined, role: string | ROLES | undefined) => {
  if (!authorizedRoles || !role) return false;

  // Rotas abertas para qualquer papel - exceto USER_APP
  if (authorizedRoles.includes(ROLES.ANY)) {
    return role !== ROLES.USER_APP && role !== "USER_APP";
  }

  // Admin, operador, viewer, etc. (papéis já previstos no enum)
  if (authorizedRoles.includes(role as ROLES)) {
    return true;
  }

  return false;
};

interface ProtectedRouteProps {
  component: React.ReactElement<any>;
  authorizedRoles?: ROLES[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component,
  authorizedRoles,
}) => {
  const { role } = useUnit(UserStore);
  const token = localStorage.getItem("authToken");

  const [authStatus, setStatus] = useState<AUTH_STATUS>(AUTH_STATUS.PROCESSING);

  useEffect(() => {
    // descomentar isso
    // if (!token) {
    //   setStatus(AUTH_STATUS.NOT_OK);
    // }

    if (authStatus === AUTH_STATUS.PROCESSING) {
      userAuth()
        .then((user) => {
          const { full_name, station, role } = user;

          setUser({ username: full_name, station, role, token });
          // descomentar isso
          // setStatus(AUTH_STATUS.AUTH_OK);
        })
        .catch(() => {
          // descomentar isso
          // toast.error("Falha ao autenticar usuário");
          // setStatus(AUTH_STATUS.NOT_OK);
        })
        .finally(() => {
          setLoading(false);

          // apagar isso
          if (!!token) {
            setStatus(AUTH_STATUS.AUTH_OK);
          } else {
            setStatus(AUTH_STATUS.NOT_OK);
          }
        });
    }
  }, [authStatus, token]);

  if (authStatus === AUTH_STATUS.PROCESSING) return <></>;

  if (authStatus === AUTH_STATUS.NOT_OK) {
    return <Navigate to={publicRoutes.login.path} replace />;
  }

  if (
    authStatus === AUTH_STATUS.AUTH_OK &&
    canAccess(authorizedRoles, role)
  ) {
    return component;
  }

  return <Navigate to={publicRoutes.default.path} replace />;
};

export default ProtectedRoute;
